import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessProfileAppResource from './BusinessProfileAppResource';
import BusinessTypeAppResource from './BusinessTypeAppResource';
import MarketAppResource from './MarketAppResource';

class RecommendedBusinessAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'Recommended-Business';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'recommended/businesses';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at'
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'businessProfileUuid',
      'businessTypeUuid',
      'marketUuid',
      'order',
      'businessProfile',
      'businessType',
      'market',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      businessProfile:             BusinessProfileAppResource,
      businessType:             BusinessTypeAppResource,
      market:             MarketAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      businessProfile: 'business_profile_uuid',
      businessType: 'business_type',
      market: 'market_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      businessProfileUuid: {
        type: 'string',
        presence: true,
      },
      businessTypeUuid: {
        type: 'string',
        presence: true,
      },
      marketUuid: {
        type: 'string',
        presence: true,
      },
      order: {
        type: 'integer',
        presence: true,
      },
    };
  }

}

export default RecommendedBusinessAppResource;
